import script from "./CallOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./CallOverlay.vue?vue&type=script&setup=true&lang=js"

import "./CallOverlay.vue?vue&type=style&index=0&id=3ab5b95b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ab5b95b"]])

export default __exports__